import {
  AimOutlined,
  AppstoreOutlined,
  BgColorsOutlined,
  CameraOutlined,
  CodeOutlined,
  CrownOutlined,
  CustomerServiceOutlined,
  DribbbleOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  HeartOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  ReadOutlined,
  RocketOutlined,
  SkinOutlined,
  SoundOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  TranslationOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import type { ComponentType } from 'react';

// A club type's icon, by the name stored on club_type.icon — the same list as
// the server's clubTypeIconOptions (apps/server/src/services/clubTypeIcons.ts).
const ICONS: Record<string, ComponentType> = {
  AimOutlined,
  AppstoreOutlined,
  BgColorsOutlined,
  CameraOutlined,
  CodeOutlined,
  CrownOutlined,
  CustomerServiceOutlined,
  DribbbleOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  HeartOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  ReadOutlined,
  RocketOutlined,
  SkinOutlined,
  SoundOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  TranslationOutlined,
  TrophyOutlined,
};

// Tints a type may get: [background, icon].
const TINTS: [string, string][] = [
  ['#eff6ff', '#2563eb'],
  ['#f0fdf4', '#16a34a'],
  ['#fff7ed', '#ea580c'],
  ['#fdf2f8', '#db2777'],
  ['#f5f3ff', '#7c3aed'],
  ['#ecfeff', '#0891b2'],
  ['#fefce8', '#ca8a04'],
  ['#fef2f2', '#dc2626'],
];

// The same name always gets the same tint.
function tintOf(name: string): [string, string] {
  let hash = 0;
  for (const ch of name) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return TINTS[Math.abs(hash) % TINTS.length];
}

interface Props {
  icon: string | null;
  // The club type's name, which picks the tint; none = neutral.
  name: string | null;
  size?: number;
}

// A club type's icon on a tinted tile; a type without one gets a neutral
// generic icon.
export default function ClubTypeIcon({ icon, name, size = 40 }: Props) {
  const Icon = (icon && ICONS[icon]) || AppstoreOutlined;
  const [bg, fg] = icon && name ? tintOf(name) : ['#f3f4f6', '#9ca3af'];
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center rounded-lg"
      style={{ width: size, height: size, backgroundColor: bg, color: fg, fontSize: size * 0.5 }}
      aria-hidden
    >
      <Icon />
    </span>
  );
}
